<template>
  <b-card no-body>
    <b-card-header class="pb-1">
      <b-card-title> Total profits made by participants </b-card-title>
      <div class="d-flex align-items-center calender">
        <feather-icon icon="CalendarIcon" size="16" />
        <flat-pickr
          @click.native="blurPicker"
          v-model="rangePicker"
          :config="{ mode: 'range' }"
          class="form-control flat-picker bg-transparent border-0 shadow-none"
          placeholder="YYYY-MM-DD"
        />
      </div>
    </b-card-header>

    <b-card-body>
      <div class="mb-1 pl-1">
        <b-skeleton width="80px" height="30px" class="mr-2" v-if="loading" />
        <div class="font-weight-bolder h1 text-info text-lighten-2" v-else>
          {{ total }}
        </div>
        <div>Total Profit</div>
      </div>
      <div v-if="loading">
        <b-skeleton width="100%" height="80px" />
      </div>
      <chartjs-component-horizontal-bar-chart
        v-else-if="horizontalBarChart.data"
        :height="this.totalProfits.length * 50"
        :data="horizontalBarChart.data"
        :options="horizontalBarChart.options"
      />
      <template v-else>
        <div
          class="d-flex align-items-center justify-content-center h-100 new-alert"
        >
          <b-alert
            show
            variant="secondary"
            class="d-flex align-items-center justify-content-center p-3 w-100"
          >
            no information
          </b-alert>
        </div>
      </template>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardBody,
  BCardHeader,
  BCardTitle,
  BSkeleton,
  BAlert,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import ChartjsComponentHorizontalBarChart from "./charts-components/ChartjsComponentHorizontalBarChart.vue";
import { $themeColors } from "@themeConfig";
const chartColors = {
  primaryColorShade: "#836AF9",
  yellowColor: "#ffe800",
  successColorShade: "#28dac6",
  warningColorShade: "#ffe802",
  warningLightColor: "#FDAC34",
  infoColorShade: "#299AFF",
  greyColor: "#4F5D70",
  blueColor: "#2c9aff",
  blueLightColor: "#84D0FF",
  greyLightColor: "#EDF1F4",
  tooltipShadow: "rgba(0, 0, 0, 0.25)",
  lineChartPrimary: "#666ee8",
  lineChartDanger: "#ff4961",
  labelColor: "#6e6b7b",
  grid_line_color: "rgba(200, 200, 200, 0.2)",
};
export default {
  components: {
    BCard,
    BCardBody,
    BCardHeader,
    BCardTitle,
    flatPickr,
    ChartjsComponentHorizontalBarChart,
    BSkeleton,
    BAlert,
  },

  data() {
    return {
      loading: false,
      total: 0,
      totalProfits: [],
      rangePick: "2022-12-01 to 2022-12-20",
      datePiker: [],
    };
  },
  computed: {
    rangePicker: {
      get: function () {
        return this.rangePick;
      },
      set: function (newValue) {
        if (this.rangePick != newValue) {
          this.rangePick = newValue;
          this.convertStringToArray();
        }
      },
    },
    horizontalBarChart() {
      return {
        options: {
          elements: {
            rectangle: {
              borderWidth: 2,
              borderSkipped: "top",
            },
          },
          tooltips: {
            // Updated default tooltip UI
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 8,
            shadowColor: chartColors.tooltipShadow,
            backgroundColor: $themeColors.light,
            titleFontColor: $themeColors.dark,
            bodyFontColor: $themeColors.dark,
          },
          responsive: true,
          maintainAspectRatio: false,
          responsiveAnimationDuration: 500,
          legend: {
            display: false,
          },
          scales: {
            xAxes: [
              {
                display: true,
                gridLines: {
                  zeroLineColor: chartColors.grid_line_color,
                  borderColor: "transparent",
                  color: chartColors.grid_line_color,
                  drawTicks: false,
                },
                scaleLabel: {
                  display: true,
                },
                ticks: {
                  min: 0,
                  fontColor: chartColors.labelColor,
                },
              },
            ],
            yAxes: [
              {
                display: true,
                gridLines: {
                  display: false,
                },
                scaleLabel: {
                  display: true,
                },
                ticks: {
                  fontColor: chartColors.labelColor,
                },
              },
            ],
          },
        },
        data: {
          labels: [
            ...this.totalProfits.map((item) => {
              return item.id;
            }),
          ],
          datasets: [
            {
              data: [
                ...this.totalProfits.map((item) => {
                  return item.profit;
                }),
              ],
              backgroundColor: $themeColors.info,
              borderColor: "transparent",
              barThickness: 15,
            },
          ],
        },
      };
    },
  },
  created() {
    this.convertStringToArray();
  },
  methods: {
    convertStringToArray() {
      this.datePiker = this.rangePick.split(" ");
      this.datePiker.length == 3 && !this.loading ? this.getTotalProfits() : "";
    },
    async getTotalProfits(query) {
      this.loading = true;

      try {
        const params = {
          from: this.datePiker[0],
          to: this.datePiker[2],
        };

        const { data } = await this.$http.get(
          `/panel/competitions/total-profits` + (query ? query : ""),
          { params }
        );
        this.totalProfits = data;
        this.totalProfits.map((item) => {
          this.total += item.profit;
        });
      } catch (err) {}
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.form-control {
  background-color: transparent !important;
  border: none !important;
}
.calender {
  border: 1px solid #73747e38;
  padding: 0 5px;
  border-radius: 5px;
}
</style>
